const color =
{
    agree    : 'Sélectionner',
    disagree : 'Fermer',
    title    : 'Choisir une couleur'
};

export default color ;
